import PropTypes from 'prop-types';
import React from 'react';

import { AccountPoolCard } from 'web-ui-components/lib/finance/accounts';
import { Inline } from 'web-ui-components/lib/layout/grids';

const ListOfAccountPools = ({ pools, onSelectAccountPool }) => {
  const inlineNodes = pools.map(({ currency, id, name }) => (
    <div className="account-pools__item" key={id}>
      <AccountPoolCard
        currencyCode={currency}
        onClick={() => onSelectAccountPool(id)}
        poolName={name}
      />
    </div>
  ));

  return <Inline.LeftAligned nodes={inlineNodes} />;
};

ListOfAccountPools.propTypes = {
  pools: PropTypes.array,
  onSelectAccountPool: PropTypes.func,
};

export { ListOfAccountPools };
